module.exports = __webpack_public_path__ + "static/img/1.b81dcae.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/17/zh/1.png
// module id = Nsy6
// module chunks = 0